<template>
    <div>
        <!--    Buyflow - Checkout - Information Form    -->
        <CheckoutForm
                      :last-name="meta.lastName"
                      :status="finalizeState.form"
                      :first-name="meta.firstName"
                      @clear-schedule="clearSchedule"
                      :billing-city="meta.billingCity"
                      :is-wyw-selected="isWywSelected"
                      :phone-number="meta.phoneNumber"
                      :referral-code="meta.referralCode"
                      :email-address="meta.emailAddress"
                      :billing-line1="meta.billingLine1"
                      :billing-line2="meta.billingLine2"
                      :checkout-state="finalizeState.form"
                      :open="finalizeState.open === 'form'"
                      @set-finalize-state="setFinalizeState"
                      :billing-postal-code="meta.billingPostalCode"
                      :is-self-install-eligible="isSelfInstallEligible"
                      @edit-customer-information="setNextDisabledState(true)"
                      :submit-customer-information="submitCustomerInformation"
                      :billing-state-or-province="meta.billingStateOrProvince"
        />

        <!--    Buyflow - Checkout - Install Questions    -->
        <CheckoutSelfInstall v-if="isSelfInstallEligible"
                             :install-data="installData"
                             @clear-schedule="clearSchedule"
                             :set-install-type="setInstallType"
                             :status="finalizeState.selfInstall"
                             :is-tech-delivered="isTechDelivered"
                             @set-finalize-state="setFinalizeState"
                             :open="finalizeState.open === 'selfInstall'"
                             :fetch-scheduler-times="fetchSchedulerTimes"
                             @edit-self-Install="setNextDisabledState(true)"
                             :is-self-install-eligible="isSelfInstallEligible"
                             :has-selected-self-install="hasSelectedSelfInstall"
                             :internet-equipment-selection="isEquipmentSelected"
        />

        <!--    Buyflow - Checkout - Schedule Selection    -->
        <CheckoutScheduler :uuid="meta.uuid"
                           :schedule-times="scheduleTimes"
                           :status="finalizeState.scheduler"
                           :is-tech-delivered="isTechDelivered"
                           :conversation-id="meta.conversationId"
                           @set-finalize-state="setFinalizeState"
                           @edit-scheduled-time="editScheduleTime"
                           :confirmed-date-time="confirmedDateTime"
                           :open="finalizeState.open === 'scheduler'"
                           @set-confirmed-datetime="setConfirmedDatetime"
                           :submit-schedule-install="submitScheduleInstall"
                           :is-self-install-eligible="isSelfInstallEligible"
                           :has-selected-self-install="hasSelectedSelfInstall"
                           @clear-confirmation="$refs.checkoutConfirmation.clearConfirmation()"
        />

        <!--    Buyflow - Checkout - Confirmation    -->
        <CheckoutConfirmation :state-abbr="meta.stateOrProvince"
                              ref="checkoutConfirmation"
                              :is-gwp="isGwp"
                              :has-referral-code="meta.referralCode"
                              @set-confirmed-state="setConfirmedState"
                              :open="finalizeState.open === 'confirmation'"
        />
    </div>
</template>

<script>
    import CheckoutForm from '~/Buyflow/components/CheckoutForm'
    import CheckoutScheduler from '~/Buyflow/components/CheckoutScheduler'
    import CheckoutConfirmation from '~/Buyflow/components/CheckoutConfirmation'
    import { mapActions, mapGetters, mapState } from 'vuex'
    import CheckoutSelfInstall from '../components/CheckoutSelfInstall'

    export default {
        name: 'CheckoutPage',
        components: {
            CheckoutSelfInstall,
            CheckoutForm,
            CheckoutScheduler,
            CheckoutConfirmation,
        },
        computed: {
            ...mapState({
                meta: state => state.meta,
                data: state => state.Buyflow.internet.data,
                dropStatus: state => state.Buyflow.finalize.dropStatus,
                installData: state => state.Buyflow.finalize.installData,
                finalizeState: state => state.Buyflow.finalize.finalizeState,
                scheduleTimes: state => state.Buyflow.finalize.scheduleTimes,
                selectedOfferIsAvailable: state => state.selectedOfferIsAvailable,
                confirmedDateTime: state => state.Buyflow.finalize.confirmedDateTime,
                installIsScheduled: state => state.Buyflow.finalize.installIsScheduled,
            }),
            ...mapGetters({
                isGwp: 'isGwp',
                isHidden: 'Buyflow/internet/isHidden',
                isTechDelivered: 'Buyflow/finalize/isTechDelivered',
                isEquipmentSelected: 'Buyflow/internet/isEquipmentSelected',
                isSchedulerAvailable: 'Buyflow/finalize/isSchedulerAvailable',
                isSelfInstallEligible: 'Buyflow/finalize/isSelfInstallEligible',
                hasSelectedSelfInstall: 'Buyflow/finalize/hasSelectedSelfInstall',
            }),
            isWywSelected(){
                return (!this.isEquipmentSelected(this.data.equipments.modemOptions.noModem) && !this.isEquipmentSelected(this.data.equipments.modemOptions.modemOnly))
            }
        },
        watch: {
            finalizeState(newValue, oldValue) {
                if (newValue.form === 'open' && oldValue.form !== 'open'){
                    this.setNextDisabledState(true)
                }
            }
        },
        created () {},
        mounted () {
            this.pushEvent('checkout_flow', {
                'flow_step_name': 'final step',
                'flow_step_number': '4'
            });
            this.setNextDisabledState(true)
            this.fetchDropStatus()
            this.setSessionStatus({ session_status: 4, })
            this.setCurrentStep([4,'finalize page (customer information & scheduling date)'])
            if (window?.OptimizeTest && this.dropStatus.connectStatus !== '3' && !['fiber-equal-speed','fiber','fiber-competitive','fiber-competitive-equal-speed','ohio'].includes(this.meta.marketType)){
                this.sendEvent('Self Install', 'Tap Status', 'Not Eligible')
            }
        },
        updated () {},
        destroyed () {
            this.setNextDisabledState(false)
        },
        methods: {
            clearSchedule() {
                this.clearScheduleTimes()
                this.clearScheduledInstall()
            },
            setConfirmedState (payload) {
                this.setNextDisabledState(!payload.value)
            },
            setNextDisabledState (value) {
                this.$emit('update-next-disabled-state', value)
            },
            setInstallType(payload){
                return this.submitInstallationFulfillment(payload)
            },
            editScheduleTime() {
                if (this.finalizeState.scheduler === 'uncompleted'){
                    this.clearScheduledInstall()
                }
                this.setNextDisabledState(true);
            },
            ...mapActions({
                setCurrentStep: 'Buyflow/setCurrentStep',
                setSessionStatus:  'Buyflow/setSessionStatus',
                fetchDropStatus: 'Buyflow/finalize/fetchDropStatus',
                setFinalizeState: 'Buyflow/finalize/setFinalizeState',
                clearScheduleTimes: 'Buyflow/finalize/clearScheduleTimes',
                fetchSchedulerTimes: 'Buyflow/finalize/fetchSchedulerTimes',
                setConfirmedDatetime: 'Buyflow/finalize/setConfirmedDatetime',
                submitScheduleInstall: 'Buyflow/finalize/submitScheduleInstall',
                clearScheduledInstall: 'Buyflow/finalize/clearScheduledInstall',
                submitCustomerInformation: 'Buyflow/finalize/submitCustomerInformation',
                submitInstallationFulfillment: 'Buyflow/finalize/submitInstallationFulfillment',
            })
        },
    }
</script>
